<template>
	<div class="bb-panel-wrapper">
		<section class="b360-section-container">
			<span class="b360-form-label" role="heading">Upload Image 1</span>
			<BBUploadImageCard uniqueIndex="0" />
		</section>

		<section class="b360-section-container">
			<span class="b360-form-label" role="heading">Upload Image 2</span>
			<BBUploadImageCard uniqueIndex="1" />
		</section>

		<section class="b360-section-container">
			<span class="b360-form-label" role="heading">Upload Image 3</span>
			<BBUploadImageCard uniqueIndex="2" />
		</section>
		<button class="b360-btn b360-btn--workspace-primary" @click="nextStep()">
			Next Step
		</button>
	</div>
</template>

<script>
import BBUploadImageCard from '@/components/brand-builder/bb-design/BBUploadImageCard.vue';

export default {
	name: 'BBUploadImages',
	components: {
		BBUploadImageCard,
	},
	methods: {
		nextStep() {
			this.$router.push({
				path: `/campaign-editor-workspace/${this.$route.params.campaignId}/colors`,
			});
		},
	},
};
</script>
